/**
 * @fileoverview gRPC-Web generated client stub for saufdings
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v7.36.0
// source: drinks.proto


/* eslint-disable no-unused-vars */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var user_pb = require('./user_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')
const proto = {};
proto.saufdings = require('./drinks_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.saufdings.DrinkServiceLolClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.saufdings.DrinkServiceLolPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.saufdings.Drink,
 *   !proto.saufdings.Drinklist>}
 */
const methodDescriptor_DrinkServiceLol_GetDrinks = new grpc.web.MethodDescriptor(
  '/saufdings.DrinkServiceLol/GetDrinks',
  grpc.web.MethodType.UNARY,
  proto.saufdings.Drink,
  proto.saufdings.Drinklist,
  /**
   * @param {!proto.saufdings.Drink} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.saufdings.Drinklist.deserializeBinary
);


/**
 * @param {!proto.saufdings.Drink} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.saufdings.Drinklist)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.saufdings.Drinklist>|undefined}
 *     The XHR Node Readable Stream
 */
proto.saufdings.DrinkServiceLolClient.prototype.getDrinks =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/saufdings.DrinkServiceLol/GetDrinks',
      request,
      metadata || {},
      methodDescriptor_DrinkServiceLol_GetDrinks,
      callback);
};


/**
 * @param {!proto.saufdings.Drink} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.saufdings.Drinklist>}
 *     Promise that resolves to the response
 */
proto.saufdings.DrinkServiceLolPromiseClient.prototype.getDrinks =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/saufdings.DrinkServiceLol/GetDrinks',
      request,
      metadata || {},
      methodDescriptor_DrinkServiceLol_GetDrinks);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.saufdings.ListEventsRequest,
 *   !proto.saufdings.EventList>}
 */
const methodDescriptor_DrinkServiceLol_GetEvents = new grpc.web.MethodDescriptor(
  '/saufdings.DrinkServiceLol/GetEvents',
  grpc.web.MethodType.UNARY,
  proto.saufdings.ListEventsRequest,
  proto.saufdings.EventList,
  /**
   * @param {!proto.saufdings.ListEventsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.saufdings.EventList.deserializeBinary
);


/**
 * @param {!proto.saufdings.ListEventsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.saufdings.EventList)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.saufdings.EventList>|undefined}
 *     The XHR Node Readable Stream
 */
proto.saufdings.DrinkServiceLolClient.prototype.getEvents =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/saufdings.DrinkServiceLol/GetEvents',
      request,
      metadata || {},
      methodDescriptor_DrinkServiceLol_GetEvents,
      callback);
};


/**
 * @param {!proto.saufdings.ListEventsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.saufdings.EventList>}
 *     Promise that resolves to the response
 */
proto.saufdings.DrinkServiceLolPromiseClient.prototype.getEvents =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/saufdings.DrinkServiceLol/GetEvents',
      request,
      metadata || {},
      methodDescriptor_DrinkServiceLol_GetEvents);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.users.UserData,
 *   !proto.saufdings.DrinkActiviteList>}
 */
const methodDescriptor_DrinkServiceLol_GetActivities = new grpc.web.MethodDescriptor(
  '/saufdings.DrinkServiceLol/GetActivities',
  grpc.web.MethodType.UNARY,
  user_pb.UserData,
  proto.saufdings.DrinkActiviteList,
  /**
   * @param {!proto.users.UserData} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.saufdings.DrinkActiviteList.deserializeBinary
);


/**
 * @param {!proto.users.UserData} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.saufdings.DrinkActiviteList)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.saufdings.DrinkActiviteList>|undefined}
 *     The XHR Node Readable Stream
 */
proto.saufdings.DrinkServiceLolClient.prototype.getActivities =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/saufdings.DrinkServiceLol/GetActivities',
      request,
      metadata || {},
      methodDescriptor_DrinkServiceLol_GetActivities,
      callback);
};


/**
 * @param {!proto.users.UserData} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.saufdings.DrinkActiviteList>}
 *     Promise that resolves to the response
 */
proto.saufdings.DrinkServiceLolPromiseClient.prototype.getActivities =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/saufdings.DrinkServiceLol/GetActivities',
      request,
      metadata || {},
      methodDescriptor_DrinkServiceLol_GetActivities);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.saufdings.CreateEventRequest,
 *   !proto.saufdings.Event>}
 */
const methodDescriptor_DrinkServiceLol_CreateEvent = new grpc.web.MethodDescriptor(
  '/saufdings.DrinkServiceLol/CreateEvent',
  grpc.web.MethodType.UNARY,
  proto.saufdings.CreateEventRequest,
  proto.saufdings.Event,
  /**
   * @param {!proto.saufdings.CreateEventRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.saufdings.Event.deserializeBinary
);


/**
 * @param {!proto.saufdings.CreateEventRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.saufdings.Event)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.saufdings.Event>|undefined}
 *     The XHR Node Readable Stream
 */
proto.saufdings.DrinkServiceLolClient.prototype.createEvent =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/saufdings.DrinkServiceLol/CreateEvent',
      request,
      metadata || {},
      methodDescriptor_DrinkServiceLol_CreateEvent,
      callback);
};


/**
 * @param {!proto.saufdings.CreateEventRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.saufdings.Event>}
 *     Promise that resolves to the response
 */
proto.saufdings.DrinkServiceLolPromiseClient.prototype.createEvent =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/saufdings.DrinkServiceLol/CreateEvent',
      request,
      metadata || {},
      methodDescriptor_DrinkServiceLol_CreateEvent);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.saufdings.EventMembershipRequest,
 *   !proto.saufdings.Event>}
 */
const methodDescriptor_DrinkServiceLol_JoinEvent = new grpc.web.MethodDescriptor(
  '/saufdings.DrinkServiceLol/JoinEvent',
  grpc.web.MethodType.UNARY,
  proto.saufdings.EventMembershipRequest,
  proto.saufdings.Event,
  /**
   * @param {!proto.saufdings.EventMembershipRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.saufdings.Event.deserializeBinary
);


/**
 * @param {!proto.saufdings.EventMembershipRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.saufdings.Event)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.saufdings.Event>|undefined}
 *     The XHR Node Readable Stream
 */
proto.saufdings.DrinkServiceLolClient.prototype.joinEvent =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/saufdings.DrinkServiceLol/JoinEvent',
      request,
      metadata || {},
      methodDescriptor_DrinkServiceLol_JoinEvent,
      callback);
};


/**
 * @param {!proto.saufdings.EventMembershipRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.saufdings.Event>}
 *     Promise that resolves to the response
 */
proto.saufdings.DrinkServiceLolPromiseClient.prototype.joinEvent =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/saufdings.DrinkServiceLol/JoinEvent',
      request,
      metadata || {},
      methodDescriptor_DrinkServiceLol_JoinEvent);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.saufdings.EventMembershipRequest,
 *   !proto.saufdings.Event>}
 */
const methodDescriptor_DrinkServiceLol_LeaveEvent = new grpc.web.MethodDescriptor(
  '/saufdings.DrinkServiceLol/LeaveEvent',
  grpc.web.MethodType.UNARY,
  proto.saufdings.EventMembershipRequest,
  proto.saufdings.Event,
  /**
   * @param {!proto.saufdings.EventMembershipRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.saufdings.Event.deserializeBinary
);


/**
 * @param {!proto.saufdings.EventMembershipRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.saufdings.Event)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.saufdings.Event>|undefined}
 *     The XHR Node Readable Stream
 */
proto.saufdings.DrinkServiceLolClient.prototype.leaveEvent =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/saufdings.DrinkServiceLol/LeaveEvent',
      request,
      metadata || {},
      methodDescriptor_DrinkServiceLol_LeaveEvent,
      callback);
};


/**
 * @param {!proto.saufdings.EventMembershipRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.saufdings.Event>}
 *     Promise that resolves to the response
 */
proto.saufdings.DrinkServiceLolPromiseClient.prototype.leaveEvent =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/saufdings.DrinkServiceLol/LeaveEvent',
      request,
      metadata || {},
      methodDescriptor_DrinkServiceLol_LeaveEvent);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.saufdings.EventMembershipRequest,
 *   !proto.saufdings.Event>}
 */
const methodDescriptor_DrinkServiceLol_EndEvent = new grpc.web.MethodDescriptor(
  '/saufdings.DrinkServiceLol/EndEvent',
  grpc.web.MethodType.UNARY,
  proto.saufdings.EventMembershipRequest,
  proto.saufdings.Event,
  /**
   * @param {!proto.saufdings.EventMembershipRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.saufdings.Event.deserializeBinary
);


/**
 * @param {!proto.saufdings.EventMembershipRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.saufdings.Event)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.saufdings.Event>|undefined}
 *     The XHR Node Readable Stream
 */
proto.saufdings.DrinkServiceLolClient.prototype.endEvent =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/saufdings.DrinkServiceLol/EndEvent',
      request,
      metadata || {},
      methodDescriptor_DrinkServiceLol_EndEvent,
      callback);
};


/**
 * @param {!proto.saufdings.EventMembershipRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.saufdings.Event>}
 *     Promise that resolves to the response
 */
proto.saufdings.DrinkServiceLolPromiseClient.prototype.endEvent =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/saufdings.DrinkServiceLol/EndEvent',
      request,
      metadata || {},
      methodDescriptor_DrinkServiceLol_EndEvent);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.saufdings.EventMembershipRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_DrinkServiceLol_DeleteEvent = new grpc.web.MethodDescriptor(
  '/saufdings.DrinkServiceLol/DeleteEvent',
  grpc.web.MethodType.UNARY,
  proto.saufdings.EventMembershipRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.saufdings.EventMembershipRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.saufdings.EventMembershipRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.saufdings.DrinkServiceLolClient.prototype.deleteEvent =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/saufdings.DrinkServiceLol/DeleteEvent',
      request,
      metadata || {},
      methodDescriptor_DrinkServiceLol_DeleteEvent,
      callback);
};


/**
 * @param {!proto.saufdings.EventMembershipRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.saufdings.DrinkServiceLolPromiseClient.prototype.deleteEvent =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/saufdings.DrinkServiceLol/DeleteEvent',
      request,
      metadata || {},
      methodDescriptor_DrinkServiceLol_DeleteEvent);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.users.UserData,
 *   !proto.saufdings.ActiveEventResponse>}
 */
const methodDescriptor_DrinkServiceLol_GetActiveEvent = new grpc.web.MethodDescriptor(
  '/saufdings.DrinkServiceLol/GetActiveEvent',
  grpc.web.MethodType.UNARY,
  user_pb.UserData,
  proto.saufdings.ActiveEventResponse,
  /**
   * @param {!proto.users.UserData} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.saufdings.ActiveEventResponse.deserializeBinary
);


/**
 * @param {!proto.users.UserData} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.saufdings.ActiveEventResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.saufdings.ActiveEventResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.saufdings.DrinkServiceLolClient.prototype.getActiveEvent =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/saufdings.DrinkServiceLol/GetActiveEvent',
      request,
      metadata || {},
      methodDescriptor_DrinkServiceLol_GetActiveEvent,
      callback);
};


/**
 * @param {!proto.users.UserData} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.saufdings.ActiveEventResponse>}
 *     Promise that resolves to the response
 */
proto.saufdings.DrinkServiceLolPromiseClient.prototype.getActiveEvent =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/saufdings.DrinkServiceLol/GetActiveEvent',
      request,
      metadata || {},
      methodDescriptor_DrinkServiceLol_GetActiveEvent);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.users.UserData,
 *   !proto.saufdings.EventList>}
 */
const methodDescriptor_DrinkServiceLol_ListOpenEvents = new grpc.web.MethodDescriptor(
  '/saufdings.DrinkServiceLol/ListOpenEvents',
  grpc.web.MethodType.UNARY,
  user_pb.UserData,
  proto.saufdings.EventList,
  /**
   * @param {!proto.users.UserData} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.saufdings.EventList.deserializeBinary
);


/**
 * @param {!proto.users.UserData} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.saufdings.EventList)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.saufdings.EventList>|undefined}
 *     The XHR Node Readable Stream
 */
proto.saufdings.DrinkServiceLolClient.prototype.listOpenEvents =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/saufdings.DrinkServiceLol/ListOpenEvents',
      request,
      metadata || {},
      methodDescriptor_DrinkServiceLol_ListOpenEvents,
      callback);
};


/**
 * @param {!proto.users.UserData} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.saufdings.EventList>}
 *     Promise that resolves to the response
 */
proto.saufdings.DrinkServiceLolPromiseClient.prototype.listOpenEvents =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/saufdings.DrinkServiceLol/ListOpenEvents',
      request,
      metadata || {},
      methodDescriptor_DrinkServiceLol_ListOpenEvents);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.saufdings.EventLeaderboardRequest,
 *   !proto.saufdings.EventLeaderboardResponse>}
 */
const methodDescriptor_DrinkServiceLol_GetEventLeaderboard = new grpc.web.MethodDescriptor(
  '/saufdings.DrinkServiceLol/GetEventLeaderboard',
  grpc.web.MethodType.UNARY,
  proto.saufdings.EventLeaderboardRequest,
  proto.saufdings.EventLeaderboardResponse,
  /**
   * @param {!proto.saufdings.EventLeaderboardRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.saufdings.EventLeaderboardResponse.deserializeBinary
);


/**
 * @param {!proto.saufdings.EventLeaderboardRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.saufdings.EventLeaderboardResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.saufdings.EventLeaderboardResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.saufdings.DrinkServiceLolClient.prototype.getEventLeaderboard =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/saufdings.DrinkServiceLol/GetEventLeaderboard',
      request,
      metadata || {},
      methodDescriptor_DrinkServiceLol_GetEventLeaderboard,
      callback);
};


/**
 * @param {!proto.saufdings.EventLeaderboardRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.saufdings.EventLeaderboardResponse>}
 *     Promise that resolves to the response
 */
proto.saufdings.DrinkServiceLolPromiseClient.prototype.getEventLeaderboard =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/saufdings.DrinkServiceLol/GetEventLeaderboard',
      request,
      metadata || {},
      methodDescriptor_DrinkServiceLol_GetEventLeaderboard);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.saufdings.UpdateEventAccessRequest,
 *   !proto.saufdings.Event>}
 */
const methodDescriptor_DrinkServiceLol_UpdateEventAccess = new grpc.web.MethodDescriptor(
  '/saufdings.DrinkServiceLol/UpdateEventAccess',
  grpc.web.MethodType.UNARY,
  proto.saufdings.UpdateEventAccessRequest,
  proto.saufdings.Event,
  /**
   * @param {!proto.saufdings.UpdateEventAccessRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.saufdings.Event.deserializeBinary
);


/**
 * @param {!proto.saufdings.UpdateEventAccessRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.saufdings.Event)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.saufdings.Event>|undefined}
 *     The XHR Node Readable Stream
 */
proto.saufdings.DrinkServiceLolClient.prototype.updateEventAccess =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/saufdings.DrinkServiceLol/UpdateEventAccess',
      request,
      metadata || {},
      methodDescriptor_DrinkServiceLol_UpdateEventAccess,
      callback);
};


/**
 * @param {!proto.saufdings.UpdateEventAccessRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.saufdings.Event>}
 *     Promise that resolves to the response
 */
proto.saufdings.DrinkServiceLolPromiseClient.prototype.updateEventAccess =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/saufdings.DrinkServiceLol/UpdateEventAccess',
      request,
      metadata || {},
      methodDescriptor_DrinkServiceLol_UpdateEventAccess);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.saufdings.DrinkActivity,
 *   !proto.saufdings.DrinkActivity>}
 */
const methodDescriptor_DrinkServiceLol_AddDrinkingEvent = new grpc.web.MethodDescriptor(
  '/saufdings.DrinkServiceLol/AddDrinkingEvent',
  grpc.web.MethodType.UNARY,
  proto.saufdings.DrinkActivity,
  proto.saufdings.DrinkActivity,
  /**
   * @param {!proto.saufdings.DrinkActivity} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.saufdings.DrinkActivity.deserializeBinary
);


/**
 * @param {!proto.saufdings.DrinkActivity} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.saufdings.DrinkActivity)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.saufdings.DrinkActivity>|undefined}
 *     The XHR Node Readable Stream
 */
proto.saufdings.DrinkServiceLolClient.prototype.addDrinkingEvent =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/saufdings.DrinkServiceLol/AddDrinkingEvent',
      request,
      metadata || {},
      methodDescriptor_DrinkServiceLol_AddDrinkingEvent,
      callback);
};


/**
 * @param {!proto.saufdings.DrinkActivity} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.saufdings.DrinkActivity>}
 *     Promise that resolves to the response
 */
proto.saufdings.DrinkServiceLolPromiseClient.prototype.addDrinkingEvent =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/saufdings.DrinkServiceLol/AddDrinkingEvent',
      request,
      metadata || {},
      methodDescriptor_DrinkServiceLol_AddDrinkingEvent);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.saufdings.DrinkActivity,
 *   !proto.saufdings.DrinkActivity>}
 */
const methodDescriptor_DrinkServiceLol_UpdateDrinkingEvent = new grpc.web.MethodDescriptor(
  '/saufdings.DrinkServiceLol/UpdateDrinkingEvent',
  grpc.web.MethodType.UNARY,
  proto.saufdings.DrinkActivity,
  proto.saufdings.DrinkActivity,
  /**
   * @param {!proto.saufdings.DrinkActivity} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.saufdings.DrinkActivity.deserializeBinary
);


/**
 * @param {!proto.saufdings.DrinkActivity} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.saufdings.DrinkActivity)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.saufdings.DrinkActivity>|undefined}
 *     The XHR Node Readable Stream
 */
proto.saufdings.DrinkServiceLolClient.prototype.updateDrinkingEvent =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/saufdings.DrinkServiceLol/UpdateDrinkingEvent',
      request,
      metadata || {},
      methodDescriptor_DrinkServiceLol_UpdateDrinkingEvent,
      callback);
};


/**
 * @param {!proto.saufdings.DrinkActivity} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.saufdings.DrinkActivity>}
 *     Promise that resolves to the response
 */
proto.saufdings.DrinkServiceLolPromiseClient.prototype.updateDrinkingEvent =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/saufdings.DrinkServiceLol/UpdateDrinkingEvent',
      request,
      metadata || {},
      methodDescriptor_DrinkServiceLol_UpdateDrinkingEvent);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.saufdings.DrinkActivity,
 *   !proto.saufdings.DrinkActivity>}
 */
const methodDescriptor_DrinkServiceLol_DeleteDrinkingEvent = new grpc.web.MethodDescriptor(
  '/saufdings.DrinkServiceLol/DeleteDrinkingEvent',
  grpc.web.MethodType.UNARY,
  proto.saufdings.DrinkActivity,
  proto.saufdings.DrinkActivity,
  /**
   * @param {!proto.saufdings.DrinkActivity} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.saufdings.DrinkActivity.deserializeBinary
);


/**
 * @param {!proto.saufdings.DrinkActivity} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.saufdings.DrinkActivity)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.saufdings.DrinkActivity>|undefined}
 *     The XHR Node Readable Stream
 */
proto.saufdings.DrinkServiceLolClient.prototype.deleteDrinkingEvent =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/saufdings.DrinkServiceLol/DeleteDrinkingEvent',
      request,
      metadata || {},
      methodDescriptor_DrinkServiceLol_DeleteDrinkingEvent,
      callback);
};


/**
 * @param {!proto.saufdings.DrinkActivity} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.saufdings.DrinkActivity>}
 *     Promise that resolves to the response
 */
proto.saufdings.DrinkServiceLolPromiseClient.prototype.deleteDrinkingEvent =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/saufdings.DrinkServiceLol/DeleteDrinkingEvent',
      request,
      metadata || {},
      methodDescriptor_DrinkServiceLol_DeleteDrinkingEvent);
};


module.exports = proto.saufdings;

